// extracted by mini-css-extract-plugin
module.exports = {"section":"news-ticker_section__HBnhn","headline":"news-ticker_headline__pQzgq","date":"news-ticker_date__VWBar"};